<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="mask-close" @click="$emit('close')"></div>
            <div class="modal-wrapper justify-content-between">
                <div class="modal-container col-12 col-md-6 col-lg-6 mt-xl-4 mt-sm-0 ">
                    <div class="modal-header direction-ltr" :class="{ 'no-border-bottom': !title }">
                        <slot name="header">
                            <button v-if="!mobile" type="button" class="close pull-left ml-0 pl-0 pt-0 mt-0" data-dismiss="modal" aria-label="Close" @click="$emit('close')">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <button v-else type="button" class="close close-mobile pull-left ml-0 pl-0 pt-0 mt-0" data-dismiss="modal" aria-label="Close" @click="$emit('close')">
                                <i class="fa fa-chevron-left" aria-hidden="true"></i>
                            </button>
                            <h3 v-if="title" class="modal-title modal-title text-center col">{{ title }}</h3>
                        </slot>
                    </div>
                    <div class="modal-body">
                        <slot name="body">

                        </slot>
                    </div>
                    <div v-if="title" class="modal-footer">
                        <slot name="footer">
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
    export default {
        props:['title','mobile'],
    }
</script>

<style lang="css" scoped>
    .close:focus {
        border:none;
        outline: none;
    }
    .close {
       cursor: pointer;
    }
    .modal-mask {
        position: fixed;
        z-index: 10000;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, .6);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: block;
        overflow-y: auto;
        vertical-align: middle;
        width: 100%;
        height: 100%;
    }
    .mask-close{
      position: absolute;
        top:0;
        left:0;
        width: 100%;
        height: 100%;
    }
    .modal-container {
        margin: auto;
        z-index: 100;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
        -webkit-overflow-scrolling: touch;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #000;
        font-weight: 300;
    }

    .modal-body {
        margin: 20px 0;
        -webkit-overflow-scrolling: touch;
    }

    .modal-default-button {
        float: right;
    }

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }
    @media(max-width:767px) {
        .modal-mask {
            margin: 0!important;
            max-width: none!important;
            position: fixed!important;
            left: 0!important;
            right: 0!important;
            top: 0!important;
            bottom: 0!important;
        }
        .modal-container {
            min-height: 100%;
            min-width: 100%;
            height: 100%!important;
            position: fixed!important;
            left: 0!important;
            right: 0!important;
            top: 0!important;
            bottom: 0!important;
            margin: 0!important;
            overflow-y: auto;
        }
        .no-border-bottom {
            border-bottom: none;
        }
    }
    .direction-ltr {
        direction: ltr !important;
    }
</style>